import { FC } from 'react'
import { Box, Typography } from '@mui/material'
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined'
import { PRIMARY_COLORS_VARIANTS } from '@/utils/constants/colors'
import { HighlightedBoxElement } from 'components/shared/HighlightedBoxElement'
import { MOBILE_QUERY } from 'components/shared/bottomNavStyles'

// Desktop size, then the smaller mobile size.
const fontSize = (desktop: string, mobile: string) => ({
  fontSize: desktop,
  [MOBILE_QUERY]: { fontSize: mobile },
})

interface TotalAvailableRowProps {
  amount: string
  layout?: 'row' | 'stacked'
}

// Cash + site credit (matches the nav / header balance). Styled like the Site Credit card.
export const TotalAvailableRow: FC<TotalAvailableRowProps> = ({ amount, layout = 'row' }) => (
  <HighlightedBoxElement
    boxProps={{
      sx: {
        border: `2px solid ${PRIMARY_COLORS_VARIANTS[500]}`,
        boxShadow: '0 4px 14px rgba(255, 193, 7, 0.25)',
      },
    }}
  >
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Box display="flex" alignItems="center" gap={1}>
        <Box
          display="flex"
          alignItems="center"
          p={0.5}
          borderRadius="100%"
          color={PRIMARY_COLORS_VARIANTS[650]}
          bgcolor={PRIMARY_COLORS_VARIANTS[400]}
        >
          <AccountBalanceWalletOutlinedIcon sx={{ fontSize: '16px' }} />
        </Box>
        {layout === 'stacked' ? (
          <Box display="flex" flexDirection="column">
            <Typography
              variant="body2"
              component="div"
              lineHeight="0.875rem"
              fontWeight={700}
              sx={fontSize('0.75rem', '0.6875rem')}
              color={PRIMARY_COLORS_VARIANTS[650]}
            >
              Total available
            </Typography>
            <Typography
              variant="body2"
              component="div"
              lineHeight="1.25rem"
              sx={fontSize('1rem', '0.875rem')}
              fontWeight={900}
              color={PRIMARY_COLORS_VARIANTS[650]}
            >
              {amount}
            </Typography>
          </Box>
        ) : (
          <Typography
            variant="body2"
            component="div"
            fontWeight={700}
            sx={fontSize('14px', '12px')}
            color={PRIMARY_COLORS_VARIANTS[650]}
          >
            TOTAL AVAILABLE
          </Typography>
        )}
      </Box>
      {layout === 'row' && (
        <Typography
          variant="body2"
          component="div"
          fontWeight={900}
          sx={fontSize('1.125rem', '0.9375rem')}
          color={PRIMARY_COLORS_VARIANTS[650]}
        >
          {amount}
        </Typography>
      )}
    </Box>
  </HighlightedBoxElement>
)
